import CouponApi from '@apis/coupon/CouponApi';
import queries from '@apis/queries';
import useLoading from '@hooks/ui/useLoading';
import useToast from '@hooks/ui/useToast';
import { DownloadableCouponRow } from '@models/coupon';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';

function useDownloadCoupon(
  coupon: DownloadableCouponRow,
  setPage: Dispatch<SetStateAction<number>>,
) {
  const { eventId } = coupon;
  const queryClient = useQueryClient();
  const toast = useToast();
  const { startLoading, stopLoading } = useLoading();
  const { push } = useFlow();
  const { mutate } = useMutation({
    mutationFn: CouponApi.downloadCoupon,
    onMutate() {
      startLoading();
    },
    onSuccess() {
      setPage(0);
      queryClient.invalidateQueries({ queryKey: queries.coupons._def });
      push('CouponDownloadModal', {});
    },
    onError(e: AxiosError<ErrorResponse>) {
      console.error(e);
      toast.error(e.response?.data?.message || '쿠폰 다운로드에 실패했습니다.');
    },
    onSettled() {
      stopLoading();
    },
  });
  return () => {
    mutate(eventId);
  };
}

export default useDownloadCoupon;
